module.exports = __webpack_public_path__ + "img/purchase_image.8cf3ac1c.jpeg";